.height100 {
  height: 100%;
}

.center {
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnWebGl {
  padding: 50px;
}

.entete {
  font-weight: bold;
  font-size: large;
  padding: 50px;
}
